import {
    SET_EDITING_EUTR_ELEMENTS,
    SET_EDITING_EUTR_ELEMENT,
    SET_EDITING_EUTR_PRE_SUPPLIER,
    EutrElement,
    EutrPreSupplier
} from "./types";

export function setEditingEutrElements(elements: Array<EutrElement>) {
    return {
        type: SET_EDITING_EUTR_ELEMENTS,
        payload: elements
    };
}

export function setEditingEutrElement(element: EutrElement) {
    return {
        type: SET_EDITING_EUTR_ELEMENT,
        payload: element
    };
}

export function setEditingEutrPreSupplier(supplier: EutrPreSupplier) {
    return {
        type: SET_EDITING_EUTR_PRE_SUPPLIER,
        payload: supplier
    };
}